const local = {
  bookdemo: {
    Link: "https://agentrai-bookdemo.stage.neuralcompany.team/agentrai",
    agentTrustBookDemoLink:
      "https://agenttrust-bookdemo.stage.neuralcompany.team/agenttrust",
  },
};

const dev = {
  bookdemo: {
    Link: "https://agentrai-bookdemo.stage.neuralcompany.team/agentrai",
    agentTrustBookDemoLink:
      "https://agenttrust-bookdemo.stage.neuralcompany.team/agenttrust",
  },
};

const prod = {
  bookdemo: {
    Link: "https://demo.akira.ai/agentrai/",
    agentTrustBookDemoLink: "https://demo.akira.ai/agenttrust/",
  },
};

const config =
  process.env.REACT_APP_STAGE === "production"
    ? prod
    : process.env.REACT_APP_STAGE === "development"
    ? dev
    : // : process.env.REACT_APP_STAGE === "uat"
      // ? uat
      local;
// eslint-disable-next-line
export default {
  ...config,
};
